import Vue from "vue";

Vue.directive("basket-item-count", {
    update(el, binding)
    {
        const count = parseInt(binding.value || 0);

        el.innerHTML = count;

        el.style.display = count > 0 ? "inline" : "none";
    }
});
